import { z } from "zod";

import { GuestPageVisibilityMode } from "@/lib/gql/__generated__/graphql";
import { MagazineAnalyticsSettingInputSchema } from "@/lib/zod/__generated__/validation-schema";

import { GTMID_ZOD_SCHEMA_MAX_LENGTH } from "@/components/features/_shared/validation-schema/validation-schema";

export const magazineAnalyticsSettingInputZodSchema = MagazineAnalyticsSettingInputSchema.extend({
	// マガジンの公開状態（検索に表示しないかどうか）。公開設定（guestPageVisibilitySettings）として一緒に保存する
	guestPageVisibility: z.nativeEnum(GuestPageVisibilityMode),
})
	.refine(({ pixelID, pixelAvailable }) => !(pixelAvailable && !pixelID), {
		message: "pixel IDは必須入力です",
		path: ["pixelID"],
	}) // gtmIDZodSchema を使いたいが gtmAvailable によって条件が変化するため、ここで別途定義
	.superRefine(({ gtmAvailable, gtmID }, ctx) => {
		if (!gtmAvailable) {
			// GTMを利用しない場合はチェックしない
			return z.NEVER;
		}

		if (!gtmID?.startsWith("GTM-")) {
			return ctx.addIssue({
				path: ["gtmID"],
				code: z.ZodIssueCode.custom,
				message: "GTM-から始まる必要があります",
			});
		}

		if (gtmID && GTMID_ZOD_SCHEMA_MAX_LENGTH < gtmID.length) {
			return ctx.addIssue({
				path: ["gtmID"],
				code: z.ZodIssueCode.custom,
				message: `11文字、または12文字で入力してください`,
			});
		}

		return z.NEVER;
	});

export type MagazineAnalyticsSettingInputZodSchemaType = z.infer<typeof magazineAnalyticsSettingInputZodSchema>;
